import { Component, Input } from '@angular/core';
import { MaTopFiveIndustriesChartDTO } from '../../../dto/MaByIndustryChartDTO';
import { NgForOf } from '@angular/common';
import { SharedComponentsModule } from '../../../../shared/module/shared-components.module';

@Component({
  selector: 'app-ma-top-five-industries-table',
  templateUrl: './ma-top-five-industries-table.component.html',
  styleUrls: ['./ma-top-five-industries-table.component.scss'],
  standalone: true,
  imports: [
    NgForOf,
    SharedComponentsModule,
  ],
})
export class MaTopFiveIndustriesTableComponent {
  @Input({ required: true }) data: MaTopFiveIndustriesChartDTO;
  @Input({ required: true }) chartType: 'numberOfDeals' | 'capitalRaised';
}
